import FolderShare from "./FolderShare";
import Footer from "./Footer";
import ItemsShare from "./ItemsShare";
import QuickShare from "./QuickShare";
import ShareMembers from "./ShareMembers";
import ShareOption from "./ShareOption";

const shareFormDataComponents = {
  FolderShare,
  Footer,
  ItemsShare,
  QuickShare,
  ShareMembers,
  ShareOption
}

export default shareFormDataComponents;